<template>
  <div class="center">
    <img src="@/assets/404_images/404.png" alt />
    <p>您要访问的页面已丢失</p>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="scss" scope>
.center {
  box-sizing: border-box;
  padding: 30% 10%;
  line-height: 50px;
  font-size: 16px;
  text-align: center;
  img {
    width: 150px;
  }
}
</style>
